import React, { useEffect, useState } from "react";

// Minimal types used by the component
export interface MessageResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export interface ItemForSellModel {
  productName?: string;
  productCode?: string;
  price?: number;
}

export interface TblPromotionSaleOrder {
  id: number;
  code: string;
  effDate?: string;
  expDate?: string;
  promotionNote?: string;
  moTa?: string;
  htmlDescription?: string;
}

export interface TblPromotionItemPrimaryTest {
  itemCode: string;
  discountAmount?: number;
}

export interface TblPromotionItemGiftTest {
  itemForSellModel?: ItemForSellModel;
  attribute1?: string;
}

export interface ListPromotionModel {
  tblPromotion: TblPromotionSaleOrder;
  tblPromotionItemPrimary?: TblPromotionItemPrimaryTest[];
  tblPromotionItemGift?: TblPromotionItemGiftTest[];
}

function decodeHTMLEntities(input?: string) {
  if (!input) return "";
  return input
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
}

export default function UIGiftPromotion({
  attr14,
  itemCode,
}: {
  attr14?: string | null;
  itemCode?: string;
}) {
  const [loading, setLoading] = useState(false);
  const [promotionData, setPromotionData] = useState<MessageResponse<
    ListPromotionModel[]
  > | null>(null);

  useEffect(() => {
    setLoading(true);
    if (attr14) {
      try {
        const excludeCodes = [
          "KM3009258316",
          "KM0110258340",
          "KM2609257682",
          "KM2609257681",
          "KM2609257660",
        ];
        const parsedData: ListPromotionModel[] = JSON.parse(attr14);
        const now = new Date();
        const filteredData = parsedData
          .filter((x) => !excludeCodes.includes(x.tblPromotion.code))
          .filter((x) => {
            const effRaw = x.tblPromotion?.effDate;
            const expRaw = x.tblPromotion?.expDate;
            const eff = effRaw ? new Date(effRaw) : null;
            const exp = expRaw ? new Date(expRaw) : null;
            if (eff && isNaN(eff.getTime())) return false;
            if (exp && isNaN(exp.getTime())) return false;
            if (eff && now < eff) return false;
            if (exp && now > exp) return false;
            return true;
          });
        setPromotionData({ success: true, message: "", data: filteredData });
        try {
          console.log(
            "[PromotionShowCSRPlain] parsed promotions summary:",
            filteredData.map((p) => ({
              code: p.tblPromotion?.code,
              effDate: p.tblPromotion?.effDate,
              expDate: p.tblPromotion?.expDate,
              giftCount: (p.tblPromotionItemGift || []).length,
              primaryCount: (p.tblPromotionItemPrimary || []).length,
              moTaPreview: (
                (p as any)?.moTa ||
                p.tblPromotion?.moTa ||
                ""
              ).substring(0, 200),
            })),
          );
        } catch (e) {
          console.warn(
            "[PromotionShowCSRPlain] failed to log parsed promotions",
            e,
          );
        }
      } catch (error) {
        setPromotionData(null);
        console.error("Error parsing attr14:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setPromotionData(null);
      setLoading(false);
    }
  }, [attr14]);

  const hasGiftOrDiscount =
    !!promotionData && !!promotionData.data && promotionData.data.length > 0;

  if (loading) return <div style={{ padding: 12 }}>Đang tải...</div>;
  if (!hasGiftOrDiscount) return null;

  return (
    <div>
      {/* <div>
        <i style={{ marginRight: 8 }} className="fa-solid fa-gift" /> KHUYẾN MẠI
        VÀ QUÀ TẶNG
      </div> */}
      <div style={{ padding: "12px 0px" }}>
        {/* Gifts & vouchers block */}
        <div style={{ marginBottom: 12 }}>
          <span style={{ fontSize: 14 }}>DANH SÁCH QUÀ TẶNG</span>
          <div style={{ marginLeft: 16 }}>
            {promotionData?.data?.map((x, index) => {
              const primary = x.tblPromotionItemPrimary?.find(
                (p) => p.itemCode === itemCode,
              );
              const discountAmount = primary?.discountAmount ?? 0;
              const note = x.tblPromotion?.promotionNote;
              return (
                <div key={index} style={{ marginBottom: 8 }}>
                  {discountAmount > 0 && (
                    <div>
                      Tặng voucher tiền mặt trị giá{" "}
                      <strong style={{ color: "red" }}>
                        {discountAmount.toLocaleString()}đ
                      </strong>
                    </div>
                  )}
                  {x.tblPromotionItemGift?.map((gift, giftIndex) => {
                    const name =
                      gift.itemForSellModel?.productName ?? "Quà tặng";
                    const code = gift.itemForSellModel?.productCode ?? "";
                    const price = gift.itemForSellModel?.price ?? 0;
                    const attribute1 = gift.attribute1;
                    return (
                      <div
                        key={`${index}-${giftIndex}`}
                        style={{ marginTop: 6 }}
                      >
                        <span>
                          Tặng {name.charAt(0).toLowerCase() + name.slice(1)}{" "}
                          <strong style={{ color: "red" }}>
                            {price > 0 ? price.toLocaleString() + "đ" : ""}
                          </strong>
                          {code ? (
                            <span>
                              {" "}
                              (
                              <span style={{ textTransform: "uppercase" }}>
                                {code}
                              </span>
                              )
                            </span>
                          ) : null}{" "}
                          <a href={`/tim?q=${code || name}`} target="_blank">
                            (Xem chi tiết)
                          </a>
                        </span>
                        {attribute1 ? (
                          <div
                            style={{
                              marginTop: 4,
                              fontStyle: "italic",
                              color: "#666",
                            }}
                          >
                            ({attribute1})
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                  {note ? (
                    <div
                      style={{
                        marginTop: 6,
                        color: "red",
                        fontStyle: "italic",
                      }}
                    >
                      ({note})
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>

        {/* Description blocks (moTa / htmlDescription) */}
        {promotionData?.data?.map((x, promoIndex) => {
          const moTaRaw =
            (x as any)?.moTa ||
            x.tblPromotion?.moTa ||
            x.tblPromotion?.htmlDescription ||
            null;
          if (!moTaRaw) return null;
          const decoded = decodeHTMLEntities(moTaRaw);
          return (
            <div key={`mo-${promoIndex}`} style={{ marginBottom: 12 }}>
              {/* <div style={{ fontWeight: 700, color: "#c00", marginBottom: 6 }}>
                {x.tblPromotion?.code}
              </div> */}
              <div
                style={{ background: "#fff", borderRadius: 6 }}
                dangerouslySetInnerHTML={{ __html: decoded }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
